/* Acorn & Pip — brand section behaviour */
(function () {
  if (window.__apBrand) return; window.__apBrand = true;

  // Quick add to basket
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ap-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-ap-add')), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart.js').then(function (c) { return c.json(); }); })
      .then(function (cart) {
        btn.classList.add('is-added'); btn.textContent = 'Added ✓';
        document.querySelectorAll('.cart-count, .cart-count-bubble span, [data-cart-count], .header__cart-count').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; }, 2200);
      })
      .catch(function () { btn.textContent = 'Sorry, try again'; btn.disabled = false; });
  });

  // Countdowns
  function counts() {
    document.querySelectorAll('[data-ap-countdown]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-ap-countdown') + 'T23:59:00');
      var days = Math.ceil((end - new Date()) / 86400000);
      if (isNaN(days) || days < 0) { el.hidden = true; return; }
      var n = el.querySelector('strong'); if (n) n.textContent = days;
      var u = el.querySelector('[data-ap-unit]'); if (u) u.textContent = days === 1 ? 'day' : 'days';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', counts); else counts();
  document.addEventListener('shopify:section:load', counts);
})();

/* Basket drawer: "Make it a gift" */
(function () {
  if (window.__apGiftWired) return;
  window.__apGiftWired = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function post(url, body) {
    return fetch(root + url.replace(/^\//, ''), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: false } }));
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var box = t.closest('[data-ap-gift]');
    if (!box) return;
    var id = box.getAttribute('data-wrap-id');
    if (t.matches('[data-ap-gift-toggle]')) {
      var on = t.checked;
      box.classList.toggle('is-on', on);
      box.classList.add('is-busy');
      var note = box.querySelector('[data-ap-gift-note]');
      if (note) note.closest('.ap-giftbox__note').hidden = !on;
      var updates = {}; updates[id] = on ? 1 : 0;
      post('/cart/update.js', { updates: updates, attributes: on ? { 'gift-wrapping': 'yes' } : { 'gift-wrapping': '', 'gift-note': '' } })
        .then(refreshDrawer, refreshDrawer);
    } else if (t.matches('[data-ap-gift-note]')) {
      post('/cart/update.js', { attributes: { 'gift-note': t.value } });
    }
  });
  /* If someone removes everything except the wrap, take the wrap out too. */
  function tidy() {
    var box = document.querySelector('[data-ap-gift]');
    var id = box && box.getAttribute('data-wrap-id');
    fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items || !c.items.length) return;
      var wrapId = id ? Number(id) : null;
      if (!wrapId) return;
      var others = c.items.filter(function (i) { return i.variant_id !== wrapId; });
      if (others.length === 0) {
        var u = {}; u[wrapId] = 0;
        post('/cart/update.js', { updates: u, attributes: { 'gift-wrapping': '', 'gift-note': '' } }).then(refreshDrawer);
      }
    }).catch(function () {});
  }
  document.addEventListener('theme:cartchanged', function () { setTimeout(tidy, 900); });
})();
